import AbstractChannel from './AbstractChannel'

export default class ReservationsLab extends AbstractChannel {

  name = 'reservations_lab'
  title = 'Reservations Lab'
  titleShort = 'Res Lab'
  color = '#dbdb8d'

  supportedFeatures = ['blackouts']

}
